import { useContext } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import CollapsableMenuItem from './CollapsableMenuItem'
import { GlobalContext } from '../../../services/context/DataContext'

const MenuItem = ({
  props: { level, name, linkTo, text, image, subMenus },
  noBottomBorder
}) => {
  const classes = useStyles({ noBottomBorder })
  const { activeTabData } = useContext(GlobalContext)
  const [activeTab, setActiveTab] = activeTabData
  const menuClicked = activeTab === linkTo

  const getImageAltText = () =>
    text.replace(/[\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/g, '')

  return (
    <>
      {subMenus?.length ? (
        <CollapsableMenuItem props={{ level, name, linkTo, text, image }}>
          {subMenus}
        </CollapsableMenuItem>
      ) : (
        <div
          className={`${classes.root} ${classes[`level${level}`]} ${
            menuClicked && classes.menuClicked
          }`}
          onClick={() => linkTo && setActiveTab(linkTo)}
        >
          <img
            className={classes.menuItemImage}
            src={image}
            alt={getImageAltText()}
          />
          <div className={classes.menuItemText}>{text}</div>
        </div>
      )}
    </>
  )
}

export default MenuItem

const useStyles = makeStyles((theme, props) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingRight: '5px',
    paddingTop: '10px',
    paddingBottom: '10px',
    color: theme.palette.tertiary.main,
    borderBottom: (props) =>
      props.noBottomBorder
        ? 'none'
        : `1px solid ${theme.palette.secondary.main}`,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.quaternary.main,
      color: theme.palette.primary.accent
    }
  },
  menuItemText: {
    ...theme.typography.h3,
    fontSize: '13px'
  },
  menuItemImage: {
    width: '20px',
    height: '20px',
    marginRight: '10px'
  },
  level0: {
    paddingLeft: '15px'
  },
  level1: {
    paddingLeft: '30px'
  },
  level2: {
    paddingLeft: '45px'
  },
  menuClicked: {
    backgroundColor: theme.palette.quaternary.main,
    color: theme.palette.primary.accent
  }
}))
